import type { DataAdapter, AdapterKind } from './types';
import { MockAdapter } from './mockAdapter';
import { ApiAdapter } from './apiAdapter';

export function createAdapter(kind: AdapterKind, opts: { failMode?: boolean } = {}): DataAdapter {
  if (kind === 'api') return new ApiAdapter(!!opts.failMode);
  return new MockAdapter();
}

export const ADAPTER_OPTIONS: { kind: AdapterKind; label: string; description: string }[] = [
  { kind: 'mock', label: 'Lokal adapter (standard)', description: 'Lokalt, deterministisk eksempeldatasett. Fungerer frakoblet.' },
  { kind: 'api', label: 'Simulert API', description: 'Henter samme eksempeldatasett fra en lesende API-tjeneste (FastAPI). Viser adapterbytte uten omskriving av skjermene.' },
];
